import api from './api';

interface ProductData {
  empresa_id: number;
  grupo_id: number;
  descricao: string;
  codigo?: string;
  gtin?: string;
  observacao?: string;
  preco: number;
  unidade_medida_id: number;
  imagem?: File | string;
  tipo: number;
  controla_grade?: number;
  ordem?: number;
}

interface NewProductRequest {
  produto_id: number;
  grupo_produto_id: number;
}

const newProductRequest = async ({
  empresa_id,
  grupo_id,
  descricao,
  codigo,
  gtin,
  observacao,
  preco,
  imagem,
  unidade_medida_id,
  tipo,
  controla_grade,
  ordem,
}: ProductData): Promise<NewProductRequest> => {
  const dataForm = new FormData();

  dataForm.append('empresa_id', empresa_id.toString());
  dataForm.append('unidade_medida_id', unidade_medida_id.toString());
  dataForm.append('descricao', descricao);
  dataForm.append(
    'controla_grade',
    controla_grade ? controla_grade.toString() : '0',
  );
  dataForm.append('preco', preco.toString());
  dataForm.append('tipo', tipo.toString());
  dataForm.append('ordem', ordem ? String(ordem) : '1');

  codigo && dataForm.append('codigo', codigo);
  gtin && dataForm.append('gtin', gtin);
  observacao && dataForm.append('observacao', observacao);
  imagem && dataForm.append('produto_img', imagem);

  const response = await api.post(`/produto/${grupo_id}`, dataForm, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });

  const { produto, grupo } = response.data;

  return { produto_id: produto.id, grupo_produto_id: grupo.id };
};

export default newProductRequest;
